import { render, staticRenderFns } from "./InsuranceCompaniesTable.vue?vue&type=template&id=cb493148&"
import script from "./InsuranceCompaniesTable.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompaniesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports